export const STORAGE_KEYS = {
	AUTH_TOKEN: 'auth_token_default',
	AUTH_REMEMBER: 'auth_remember',
	AUTH_TOKEN_IMPERSONATE: 'auth_token_impersonate',
	COOKIES_DIALOG_SHOWN: 'cookiesDialogShown',
	ENABLE_ANALYTICS_COOKIES: 'enableAnalyticsCookies',
	PWA_DISMISSED_AT: 'pwaInstallDismissedAt',
	PWA_INSTALLED: 'pwaInstalled',
	GENERATION_TASKS: 'generation_tasks',
	LOGIN_STEP: 'login_step',
	/** Заказ, по которому идёт оплата. Именно localStorage, а не sessionStorage:
	 * иначе ожидание оплаты видела бы только вкладка, в которой платили. */
	BILLING_PENDING_ORDER: 'billing_pending_order',
	/** Ключи уже отправленных целей Метрики. В sessionStorage — дедупликация на вкладку,
	 * в localStorage — навсегда (оплаты по invoiceId). */
	METRIKA_GOALS_SENT: 'metrika_goals_sent',
	/** Цели, отложенные до следующей загрузки страницы (sessionStorage). */
	METRIKA_GOALS_DEFERRED: 'metrika_goals_deferred'
} as const

export const COOKIE_KEYS = {
	GUEST_ID: 'guest_id',
	// Сколько бесплатных текстовых запросов гость уже израсходовал (пока лимиты не отдаёт бэк)
	GUEST_FREE_USED: 'guest_free_used'
} as const

export const getAuthToken = (): string | null => localStorage.getItem(STORAGE_KEYS.AUTH_TOKEN)

export const authHeader = (): Record<string, string> => {
	const t = getAuthToken()
	return t ? { Authorization: `Bearer ${t}` } : {}
}
